
<svg width="70px" height="70px" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
	 <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Figma.</desc>
    <defs></defs>
	<g id="Stockholm-icons-/-Layout-/-Layout-polygon" stroke="none" stroke-width="1"  fill-rule="evenodd">
		<path d="M28 4.04145C32.3316 1.54059 37.6684 1.54059 42 4.04145L58.3109 13.4585C62.6425 15.9594 65.3109 20.5812 65.3109 25.5829V44.4171C65.3109 49.4188 62.6425 54.0406 58.3109 56.5415L42 65.9585C37.6684 68.4594 32.3316 68.4594 28 65.9585L11.6891 56.5415C7.3575 54.0406 4.68911 	49.4188 4.68911 44.4171V25.5829C4.68911 20.5812 7.3575 15.9594 11.6891 13.4585L28 4.04145Z" fill="#000000"/>
	</g>
</svg>
